import { drawerOpenAtom } from '@/store/ui/drawer';
import { selectedProjectIdAtom } from '@/store/vehicle/selectedProjectId';
import { selectedProjectIdsAtom } from '@/store/vehicles/selectedProjectIds';
import { toProjectsParam } from '@/utils/projectsParam';
import { useAtom, useAtomValue } from 'jotai';
import { useMemo } from 'react';

export const useSideMenu = () => {
  const [open, setOpen] = useAtom(drawerOpenAtom);
  const selectedProjectIds = useAtomValue(selectedProjectIdsAtom);
  const selectedProjectId = useAtomValue(selectedProjectIdAtom);

  const vehiclesSearchParams = useMemo(() => {
    return selectedProjectIds.length === 0
      ? undefined
      : toProjectsParam(selectedProjectIds);
  }, [selectedProjectIds]);

  const transferSearchParams = useMemo(() => {
    return selectedProjectId ? selectedProjectId : undefined;
  }, [selectedProjectId]);

  const handleClickOpen = () => {
    setOpen(true);
  };

  const handleClose = () => {
    setOpen(false);
  };

  return {
    open,
    vehiclesSearchParams,
    transferSearchParams,
    handleClickOpen,
    handleClose,
  };
};
